import Axios from "axios";
import { CommonTexts as Texts} from "../helpers/LayoutTexts";
import { TuitionAdSearchCriteria } from "../models/TuitionAdSearchCriteria";
import { buildWebStorage, setupCache } from "axios-cache-interceptor";
import { getLanguageCode } from "../helpers/Common";

const instance = Axios.create();
const axios = setupCache(instance, { storage: buildWebStorage(localStorage, 'axios-cache:') });

export async function getTeacherAd(tuitionAdId: number) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/tuition-ad", {            
            params: {
                tuitionAdId: tuitionAdId
            },
            cache: false
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getTuitionAdsCount() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/ads-count", {            
            cache: false
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getAdminAdSearchOptions() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/admin-ad-search-options", {
            params: {                
                languageCode: getLanguageCode()
            },
            cache: false
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}
export async function getAdSearchOptions(gradeCategoryIds?: string, districtIds?: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/ad-search-options", {            
            params: {
                gradeCategoryIds: gradeCategoryIds ? gradeCategoryIds : "",
                districtIds: districtIds ? districtIds : "",
                languageCode: getLanguageCode()
            },            
            cache: {                
                ttl: 1000 * 60 * 60 * 24 // 1 day
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getGradeCategorySubjects(gradeCategoryIds?: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/grade-category-subjects", {            
            params: {
                gradeCategoryIds: gradeCategoryIds ? gradeCategoryIds : "",
                languageCode: getLanguageCode()                
            },            
            cache: {                
                ttl: 1000 * 60 * 60 * 24 // 1 day
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getDistrictTowns(districtIds?: string) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/district-towns", {            
            params: {
                districtIds: districtIds ? districtIds : "",
                languageCode: getLanguageCode()
            },            
            cache: {                
                ttl: 1000 * 60 * 60 * 24 * 30 // 30 days
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postAdResponseModel(formData: FormData) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(Texts.apiBaseUrl + "tuitions/ad-post-by-admin", formData, {
            headers: {                
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function postAdEditResponseModel(formData: FormData) {
    return new Promise<any>((resolve, reject) => {
        axios
        .post(Texts.apiBaseUrl + "tuitions/ad-edit-by-admin", formData, {
            headers: {                
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getAllTeachers() {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/all-teachers", {            
            cache: false
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function getAdSearchResults(searchModel: TuitionAdSearchCriteria) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/admin-ad-search-results", {
            params: searchModel,
            cache: false
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}



export async function getTuitionAdDetails(tuitionAdId: number) {
    return new Promise<any>((resolve, reject) => {
        axios
        .get(Texts.apiBaseUrl + "tuitions/ad-with-details", {
            params: {
                tuitionAdId: tuitionAdId,
                languageCode: getLanguageCode()
            },
            cache: false
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}

export async function deleteTuitionAd(tuitionAdId: number) {
    return new Promise<any>((resolve, reject) => {
        axios
        .delete(Texts.apiBaseUrl + "tuitions/delete-ad", {            
            params: {
                tuitionAdId: tuitionAdId
            }
        })
        .then((response) => {                
            resolve(response.data);
        })
        .catch((error) => {
            reject(error);
        })
    });
}